/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* FINISHEDPRODUCT */
export const SET_FINISHEDPRODUCT_LIST = "SET_FINISHEDPRODUCT_LIST";
export const ADD_NEW_FINISHEDPRODUCT = "ADD_NEW_FINISHEDPRODUCT";
export const UPDATE_FINISHEDPRODUCT = "UPDATE_FINISHEDPRODUCT";
export const DELETE_FINISHEDPRODUCT = "DELETE_FINISHEDPRODUCT";
export const OPEN_FINISHEDPRODUCT_FORM = "OPEN_FINISHEDPRODUCT_FORM";
export const CLOSE_FINISHEDPRODUCT_FORM = "CLOSE_FINISHEDPRODUCT_FORM";
export const EDIT_SELECTED_FINISHEDPRODUCT = "EDIT_SELECTED_FINISHEDPRODUCT";
export const FINISHEDPRODUCT_FORM_TOOGLE_LOADING = "FINISHEDPRODUCT_FORM_TOOGLE_LOADING";
/* <---- FINISHEDPRODUCT ----> */

/* CLIENT */
export const SET_CLIENT_LIST = "SET_CLIENT_LIST";
export const ADD_NEW_CLIENT = "ADD_NEW_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const DELETE_CLIENT = "DELETE_CLIENT";
export const OPEN_CLIENT_FORM = "OPEN_CLIENT_FORM";
export const CLOSE_CLIENT_FORM = "CLOSE_CLIENT_FORM";
export const EDIT_SELECTED_CLIENT = "EDIT_SELECTED_CLIENT";
export const CLIENT_FORM_TOOGLE_LOADING = "CLIENT_FORM_TOOGLE_LOADING";
/* <---- CLIENT ----> */

/* CLIENTPRODUCT */
export const SET_CLIENTPRODUCT_LIST = "SET_CLIENTPRODUCT_LIST";
export const ADD_NEW_CLIENTPRODUCT = "ADD_NEW_CLIENTPRODUCT";
export const UPDATE_CLIENTPRODUCT = "UPDATE_CLIENTPRODUCT";
export const DELETE_CLIENTPRODUCT = "DELETE_CLIENTPRODUCT";
export const OPEN_CLIENTPRODUCT_FORM = "OPEN_CLIENTPRODUCT_FORM";
export const CLOSE_CLIENTPRODUCT_FORM = "CLOSE_CLIENTPRODUCT_FORM";
export const EDIT_SELECTED_CLIENTPRODUCT = "EDIT_SELECTED_CLIENTPRODUCT";
export const CLIENTPRODUCT_FORM_TOOGLE_LOADING = "CLIENTPRODUCT_FORM_TOOGLE_LOADING";
/* <---- CLIENTPRODUCT ----> */

/* MACHINE */
export const SET_MACHINE_LIST = "SET_MACHINE_LIST";
export const ADD_NEW_MACHINE = "ADD_NEW_MACHINE";
export const UPDATE_MACHINE = "UPDATE_MACHINE";
export const DELETE_MACHINE = "DELETE_MACHINE";
export const OPEN_MACHINE_FORM = "OPEN_MACHINE_FORM";
export const CLOSE_MACHINE_FORM = "CLOSE_MACHINE_FORM";
export const EDIT_SELECTED_MACHINE = "EDIT_SELECTED_MACHINE";
export const MACHINE_FORM_TOOGLE_LOADING = "MACHINE_FORM_TOOGLE_LOADING";
/* <---- MACHINE ----> */

/* ZONE */
export const SET_ZONE_LIST = "SET_ZONE_LIST";
export const ADD_NEW_ZONE = "ADD_NEW_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";
export const DELETE_ZONE = "DELETE_ZONE";
export const OPEN_ZONE_FORM = "OPEN_ZONE_FORM";
export const CLOSE_ZONE_FORM = "CLOSE_ZONE_FORM";
export const EDIT_SELECTED_ZONE = "EDIT_SELECTED_ZONE";
export const ZONE_FORM_TOOGLE_LOADING = "ZONE_FORM_TOOGLE_LOADING";
/* <---- ZONE ----> */

/* RAWMATERIAL */
export const SET_RAWMATERIAL_LIST = "SET_RAWMATERIAL_LIST";
export const ADD_NEW_RAWMATERIAL = "ADD_NEW_RAWMATERIAL";
export const UPDATE_RAWMATERIAL = "UPDATE_RAWMATERIAL";
export const DELETE_RAWMATERIAL = "DELETE_RAWMATERIAL";
export const OPEN_RAWMATERIAL_FORM = "OPEN_RAWMATERIAL_FORM";
export const CLOSE_RAWMATERIAL_FORM = "CLOSE_RAWMATERIAL_FORM";
export const EDIT_SELECTED_RAWMATERIAL = "EDIT_SELECTED_RAWMATERIAL";
export const RAWMATERIAL_FORM_TOOGLE_LOADING =
  "RAWMATERIAL_FORM_TOOGLE_LOADING";
/* <---- RAWMATERIAL ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */

/* REPCON */
export const FETCH_REPCON = "FETCH_REPCON";
/* <---- REPCON ----> */

/* NAVPRODUCTS */
export const FETCH_NAVPRODUCTS = "FETCH_NAVPRODUCTS";
/* <---- NAVPRODUCTS ----> */
